import './index.css'

import { logout } from 'actions/userActions'
import { reRenderMessageSplitDot } from 'commons/utilities'
import { MessageErrorDialog } from 'components/commons'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom'
import Admin from 'views/Admin/Admin'
// import ChangePassword from 'views/ChangePassword/ChangePassword'
import ForgotPassword from 'views/ForgotPassword/ForgotPassword'
import Login from 'views/Login/Login'

export default function App() {
  const dispatch = useDispatch()
  const userInfo = useSelector((state) => {
    if (state.userInfo && state.userInfo.userInfo && state.userInfo.userInfo.data) return state.userInfo
    return null
  })
  const [isLogout, setIsLogout] = useState(false)

  React.useEffect(() => {
    window.addEventListener('beforeunload', function (event) {
      sessionStorage.removeItem('__lock')
    })

    window.addEventListener('load', function (e) {
      if (!window.sessionStorage.__lock) {
        sessionStorage.setItem('__lock', '1')
      }
      return null
    })
    if (sessionStorage.getItem('__lock')) {
      sessionStorage.clear()
      dispatch(logout())
      console.warn('The storage was cleared.')
    }
    sessionStorage.setItem('__lock', '1')
  }, [dispatch])

  React.useEffect(() => {
    if (userInfo && userInfo.showConfirmLogout) return setIsLogout(true)
  }, [userInfo])

  return (
    <BrowserRouter>
      {isLogout && (
        <MessageErrorDialog
          message={reRenderMessageSplitDot('セッションの有効期限が切れました。', '再度ログインしてください。')}
          showModal={isLogout}
          showMessageErrorDialog={() => {
            dispatch(logout())
            setIsLogout(false)
          }}
        />
      )}
      <Switch>
        <Route path="/login" component={Login} />
        <Route path="/forgot-password" component={ForgotPassword} />
        <Route path="/customer" render={(props) => <Admin {...props} />} />
        <Redirect from="/" to="/login" />
      </Switch>
    </BrowserRouter>
  )
}
